import classNames from 'classnames/bind';
import React from 'react';

import Attitude from './Attitude';
import GPSRaw from './GPSRaw';
import styles from './index.module.scss';

import { Tabs } from '@/components/ui/dashboard/Monitor';

const cx = classNames.bind(styles);

const Monitor = ({ robotId }) => {
  return (
    <Tabs tabs={['Attitude', 'GPS Raw']}>
      <Attitude data={robotId} className={cx('attitude')} />
      <GPSRaw data={robotId} />
    </Tabs>
  );
};

export default Monitor;
